import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=4bdb5fe5&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/college/PlaceListView.css?vue&type=style&index=0&id=4bdb5fe5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb5fe5",
  null
  
)

export default component.exports